import { FC } from 'react';
import MuiBackdrop from '@mui/material/Backdrop';
import useBackdrop from 'apps/hooks/useBackdrop';
import styles from './styles.module.scss';

const Backdrop: FC = () => {
  const {
    options: { open, isStatic },
  } = useBackdrop();

  return (
    <MuiBackdrop
      sx={{ color: '#fff', zIndex: 1400 }}
      open={open}
    >
      <span className={styles.root}></span>
      <span className={styles.logoImage}></span>
    </MuiBackdrop>
  );
};

export default Backdrop;
